import React from 'react'
import styled from 'styled-components'

import { Icon } from './Icon'

const Container = styled.header `
  display: flex;
  justify-content: center;
`

const Title = styled.div `
  margin-top: 4px;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 2px;

  @media screen and (max-width: 640px) {
    margin-top: 7px;
  }
`

const Socials = styled.div `
  position: absolute;
  top: 30px;
  right: 120px;

  @media screen and (max-width: 640px) {
    margin-top: 30px;
    top: 52px;
    right: auto;
    left: 50%;
    transform: translateX(-50%);
  }
`

const Link = styled.a.attrs({ target: '_blank' }) `
  color: #393939;
  display: inline-block;
  margin-left: 20px;
  @media screen and (max-width: 640px) {
    margin-left: 10px;
    margin-right: 10px;
  }
`

const Header = () => (
  <Container>
    <Title>Federico Zerbinati Creative Consulting</Title>
    <Socials>
      <Link href="https://www.instagram.com/federicozerbinaticonsulting/?hl=it"><Icon.Instagram /></Link>
      <Link href="https://twitter.com/f_zerbinati"><Icon.Twitter /></Link>
      <Link href="https://www.linkedin.com/in/federico-zerbinati-a7382515/"><Icon.LinkedIn /></Link>
    </Socials>
  </Container>
)

// <Link href="https://www.facebook.com/federico.zerbinati"><Icon.Facebook /></Link>

export { Header }
